import { Suspense, lazy } from 'react';
import type { ReferenceProjectsPickerProps } from './ReferenceProjectsPicker';

const Picker = lazy(async () => {
    const module = await import('./ReferenceProjectsPicker');

    return { default: module.ReferenceProjectsPicker };
});

export function ReferenceProjectsPicker(props: ReferenceProjectsPickerProps) {
    return (
        <Suspense fallback={null}>
            <Picker {...props} />
        </Suspense>
    );
}

export type { ReferenceProjectsPickerProps };
